import { extractErrorMessage } from "utils/extractErrorMessage";

import type { CollaboratorAccrualsRepositoryT } from "../../domain/ports/collaboratorAccruals.repository";
import type {
  CollaboratorAccrualsApiT,
  CollaboratorAccrualsMapperT,
} from "../types/collaboratorAccruals.types";

type CollaboratorAccrualsRepositoryParamsT = {
  collaboratorAccrualsApi: CollaboratorAccrualsApiT;
  collaboratorAccrualsMapper: CollaboratorAccrualsMapperT;
};

export const createCollaboratorAccrualsRepository = ({
  collaboratorAccrualsApi,
  collaboratorAccrualsMapper,
}: CollaboratorAccrualsRepositoryParamsT): CollaboratorAccrualsRepositoryT => ({
  getAll: async ({ collaboratorId, colaboraInstanceId }) => {
    try {
      const response = await collaboratorAccrualsApi.getAll({
        collaboratorId,
        colaboraInstanceId,
      });

      if (response.status !== 200) {
        throw new Error(
          "Ocurrió un error al obtener los saldos del colaborador",
        );
      }

      return collaboratorAccrualsMapper.collaboratorAccrualsDtoToDomain(
        response.data,
      );
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al obtener los saldos del colaborador",
      );

      throw new Error(message);
    }
  },
  delete: async (accrualIds, colaboraInstanceId) => {
    try {
      const dto = collaboratorAccrualsMapper.toDeleteDto(accrualIds);
      const response = await collaboratorAccrualsApi.delete(
        dto,
        colaboraInstanceId,
      );

      if (response.status !== 200) {
        throw new Error(
          "Ocurrió un error al eliminar los saldos del colaborador",
        );
      }

      return collaboratorAccrualsMapper.deleteDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al eliminar los saldos del colaborador",
      );

      throw new Error(message);
    }
  },
  update: async (accruals, colaboraInstanceId) => {
    try {
      const dto = collaboratorAccrualsMapper.toUpdateDto(accruals);
      const response = await collaboratorAccrualsApi.update(
        dto,
        colaboraInstanceId,
      );

      if (response.status !== 200) {
        throw new Error(
          "Ocurrió un error al actualizar los saldos del colaborador",
        );
      }

      return collaboratorAccrualsMapper.updateDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al actualizar los saldos del colaborador",
      );

      throw new Error(message);
    }
  },
});
